var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00004 13.6668C1.54171 13.6668 1.14935 13.5036 0.822957 13.1772C0.496568 12.8509 0.333374 12.4585 0.333374 12.0002V2.00016C0.333374 1.54183 0.496568 1.14947 0.822957 0.823079C1.14935 0.496691 1.54171 0.333496 2.00004 0.333496H15.3334C15.7917 0.333496 16.1841 0.496691 16.5105 0.823079C16.8368 1.14947 17 1.54183 17 2.00016V12.0002C17 12.4585 16.8368 12.8509 16.5105 13.1772C16.1841 13.5036 15.7917 13.6668 15.3334 13.6668H2.00004ZM8.66671 7.8335L2.00004 3.66683V12.0002H15.3334V3.66683L8.66671 7.8335ZM8.66671 6.16683L15.3334 2.00016H2.00004L8.66671 6.16683ZM2.00004 3.66683V2.00016V12.0002V3.66683Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.260aca6b77f64d09d4f8a19702beb498.svg";
export { ForwardRef as ReactComponent };